import {QueryClient} from '@tanstack/react-query'

export function createQueryClient() {
    return new QueryClient({
        defaultOptions: {
            queries: {
                staleTime: 30_000,
                gcTime: 5 * 60_000,
                refetchOnWindowFocus: true,
                retry: (failureCount, error) => {
                    if (error?.status === 401)
                        return false
                    return failureCount < 2
                }
            },
            mutations: {
                retry: 0
            }
        }
    })
}
